export const tagsConstants = {
  BASE_PATH: '/v1/tags',
};
